// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1kll7","signatureBlock":"Footer_signatureBlock__3head","signature":"Footer_signature__3iGbd"};